import React, { useState } from 'react'
import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'
import { BetCard } from '@mobi/betslip/Components/Common/BetCard'
import { Icon } from '@mobi/component-library/Assets/Icon'
import { Button } from '@mobi/component-library/Base/Buttons'
import { Card } from '@mobi/component-library/Base/Card'
import { colors } from '@mobi/component-library/Foundations'
import { BetSummary } from '@core/Areas/KambiSports/Player/Components/Coupon/Components/BetSummary'
import { ShareButton } from '@core/Areas/KambiSports/Player/Components/Coupon/Components/Common/Buttons/ShareButton'
import { Details } from '@core/Areas/KambiSports/Player/Components/Coupon/Components/Details'
import { getKambiCouponBetType } from '@core/Areas/KambiSports/Player/helpers/getKambiCouponBetType'
import { rebuildKambiHistoryCoupon } from '@core/Areas/KambiSports/Player/helpers/rebuildKambiHistoryCoupon'

export const Coupon: React.FC<{
  historyCoupon: KambiHistoryCoupon
}> = ({ historyCoupon }) => {
  const [showConfirmButton, setShowConfirmButton] = useState<boolean>(false)
  //later ticket to fix logic when to show.
  const hasCashOut = false

  const betType = getKambiCouponBetType(historyCoupon)

  const coupon = rebuildKambiHistoryCoupon(historyCoupon)
  const expandableText = betType !== 'single' ? 'Legs & More' : undefined

  const onClickCashOut = () => {
    setShowConfirmButton(true)
  }
  const onClickConfirm = () => {
    // TODO: implement confirm handler
  }

  return (
    <Card>
      <BetSummary historyCoupon={coupon} betType={betType} />
      {showConfirmButton && (
        <Button size='md' isFullWidth color='positive' isLoading={false} onClick={onClickConfirm}>
          Confirm
        </Button>
      )}
      {/* colour for the button not right  */}
      {hasCashOut && (
        <Button
          size='md'
          isFullWidth
          color='primary_destructive'
          isLoading={false}
          onClick={onClickCashOut}
        >
          <Icon name='CustomCashOut' size='2rem' color={colors.neutral[900]} /> Cash Out
        </Button>
      )}

      <BetCard.Footer
        expandableText={expandableText}
        expandableContent={<Details historyCoupon={historyCoupon} />}
        rightSection={<ShareButton historyCoupon={coupon} />}
      />
    </Card>
  )
}
